import {ReplaySubject} from 'rxjs';
import {distinctUntilChanged, filter, pluck, startWith} from 'rxjs/operators';
import {uiMsg$} from '@/ui';

export const fiat$ = new ReplaySubject<string>(1);

export interface FUUpdateFiat {
  type: 'update-fiat';
  currency: string;
}
uiMsg$
  .pipe(
    filter((o) => o.type === 'update-fiat'),
    pluck('currency'),
    startWith<string>('USD'),
    distinctUntilChanged()
  )
  .subscribe((fiat) => fiat$.next(fiat));
